import { render, staticRenderFns } from "./LegalDocumentPage.vue?vue&type=template&id=60f4080e&scoped=true"
import script from "./LegalDocumentPage.vue?vue&type=script&lang=js"
export * from "./LegalDocumentPage.vue?vue&type=script&lang=js"
import style0 from "./LegalDocumentPage.vue?vue&type=style&index=0&id=60f4080e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4080e",
  null
  
)

export default component.exports